module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p1"
  }, [_vm._v("For Piper Vaughn, who asked for Justin’s story straight after reading "), _c('span', {
    staticClass: "t2"
  }, [_vm._v("A Bar Tender Tale")]), _vm._v(" and poked me about it until I finally relented. This one’s for you! Enjoy!")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ac69130","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/002.vue
// module id = 57
// module chunks = 0